/* Barras horizontais em ordem decrescente: um servico por linha, o nome ao lado.
 *
 * Horizontal porque sao ~100 categorias com nome longo ("WELLHUB (EX-GYMPASS)"):
 * em colunas os rotulos teriam de girar 90 graus. Uma serie so, entao uma cor so —
 * pintar mais escuro onde a barra e maior repetiria o comprimento na cor.
 *
 * E uma lista (<ol>) e nao um <svg role="img">: nome e numero ja sao texto visivel
 * em cada linha, entao o leitor de tela le o ranking como ele e. A barra e enfeite
 * aria-hidden. A cauda longa (dezenas de servicos com 1 ou 2) fica atras de um botao;
 * a lista inteira continua na tabela do ChartFrame.
 *
 * O mesmo componente desenha contagem e dinheiro: quem chama diz como formatar o
 * valor, e o espaco na ponta da barra cresce com o rotulo mais longo. */

import { useState } from "react";
import { intBR } from "../lib/format";

export interface ServiceRow {
  name: string;
  value: number;
  percent: number | null;
}

/** Sempre uma casa: "7,0%" ao lado de "7,1%", nunca "7%". */
export const fmtPercent = (v: number | null): string =>
  v === null
    ? "–"
    : v.toLocaleString("pt-BR", { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + "%";

export function ServiceBars({ rows, format = intBR, initial = 25 }: {
  rows: ServiceRow[];
  format?: (value: number) => string;
  initial?: number;
}) {
  const [all, setAll] = useState(false);
  const max = Math.max(...rows.map((r) => r.value), 1);
  const shown = all ? rows : rows.slice(0, initial);
  // Espaco reservado na ponta da barra: ~6,9px por caractere no mono de 11,5px, mais
  // o respiro. Medido sobre TODAS as linhas, para a escala nao mudar ao expandir.
  const labelW = 14 + 6.9 * Math.max(
    ...rows.map((r) => `${format(r.value)} · ${fmtPercent(r.percent)}`.length), 0);

  return (
    <div>
      <ol className="hbars">
        {shown.map((row) => (
          <li key={row.name}>
            <span className="name" title={row.name}>{row.name}</span>
            <span className="track">
              <span className="bar" aria-hidden
                    style={{ width: `calc((100% - ${labelW}px) * ${row.value / max})` }} />
              <span className="value">
                {format(row.value)} <span>· {fmtPercent(row.percent)}</span>
              </span>
            </span>
          </li>
        ))}
      </ol>

      {rows.length > initial && (
        <button className="btn" style={{ marginTop: 12 }} aria-expanded={all}
                onClick={() => setAll((v) => !v)}>
          {all ? `ver só os ${initial} primeiros` : `ver todos os ${intBR(rows.length)}`}
        </button>
      )}
    </div>
  );
}
